import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: IndexPage,
  beforeLoad: async () => {
    throw redirect({
      to: "/signup",
      search: true,
    });
  },
});

function IndexPage() {
  return <></>;
}
